"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "jerago-con-orago": {
    "ece65037": [{
      "hkey": "9f01501d",
      "slug": "jerago-con-orago",
      "name": "Jerago con Orago",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-marazzo": [{
      "hkey": "9f01501d",
      "slug": "jerago-con-orago",
      "name": "Jerago con Orago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c99d9d2b": [{
      "hkey": "9f01501d",
      "slug": "jerago-con-orago",
      "name": "Jerago con Orago",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-pilatello": [{
      "hkey": "9f01501d",
      "slug": "jerago-con-orago",
      "name": "Jerago con Orago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "18f00f40": [{
      "hkey": "9f01501d",
      "slug": "jerago-con-orago",
      "name": "Jerago con Orago",
      "primary": true,
      "skipSearch": false
    }],
    "jerago": [{
      "hkey": "9f01501d",
      "slug": "jerago-con-orago",
      "name": "Jerago con Orago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f3f5dd3e": [{
      "hkey": "9f01501d",
      "slug": "jerago-con-orago",
      "name": "Jerago con Orago",
      "primary": true,
      "skipSearch": false
    }],
    "mirasole": [{
      "hkey": "9f01501d",
      "slug": "jerago-con-orago",
      "name": "Jerago con Orago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8976c4fd": [{
      "hkey": "9f01501d",
      "slug": "jerago-con-orago",
      "name": "Jerago con Orago",
      "primary": true,
      "skipSearch": false
    }],
    "orago": [{
      "hkey": "9f01501d",
      "slug": "jerago-con-orago",
      "name": "Jerago con Orago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;